<template>
      <nav class="navbar border-bottom navBar col-md-12">
        <din class="row iconContainer">
          <a class="iconTallos" href="#" >
            <img src="../../public/img/icons/tallos-logo-branco.svg" alt="logo" class="textNavbar"/>
          </a>
        </din>
      </nav>
</template>

<script>
export default {
  name: "NavBarTermComponent",
  data() {
    return {};
  },
};
</script>

<style>
.iconTallos {
  display: flex;
  justify-content: center;
}

.navBar {
  background-color: #002D6E;
}

</style>